export function Header() {
  return (
    <header>
      <div className="logo">
        <h2>Stippets</h2>
      </div>
    </header>
  );
}
